import { Injectable } from '@angular/core';
import { AbstractUpdatedService } from '@utils/abstract-updated.service';

/**
 * Service for communicating updates to the employees invites grid, so that the underlying data can be refreshed
 */
@Injectable({ providedIn: 'root' })
export class EmployeesInvitesUpdatedService extends AbstractUpdatedService {}
